/**
 * Id de l'onglet copilote, partagé entre le manifest et les déclencheurs ✨ qui
 * l'activent programmatiquement (même pattern que `skillUpPanels`).
 */
export const COPILOT_TAB = 'admin-copilot';

/** Flag d'activation — la feature est fusionnable avant d'être montrable. */
export const COPILOT_FEATURE_FLAG = 'copilot';
